module.exports = __webpack_public_path__ + "static/media/gray.32b5bbcb.png";